export default function openNativeShare(shareApiOptions) {
  if (navigator.share) {
    return navigator.share(shareApiOptions);
  } else {
    return Promise.reject('Native share not supported on this device.');
  }
}
